// extracted by mini-css-extract-plugin
var _1 = "TemplatesMenuItem-module__animateUploadProgressBarWidth--PratH";
var _2 = "TemplatesMenuItem-module__animatedBackground--X6Q1e";
var _3 = "TemplatesMenuItem-module__header--L4lOl";
var _4 = "TemplatesMenuItem-module__submenu--nJSCT";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "header", _4 as "submenu" }
